import landingSumm from "./assets/landSumm.png";
import foryou from "./assets/foryouSumm.png";
import planSumm from "./assets/planSumm.png";
import player from "./assets/playerSumm.png";
import amDepriscoHome from "./assets/amDepriscoHome.png";
import amDepriscoCollection from "./assets/amDepriscoCollection.png";
import amDepriscoCart from "./assets/amDepriscoCart.png";
import clientAnalyticsOverview from "./assets/clientAnalyticsOverview.png";
import clientAnalyticsConnections from "./assets/clientAnalyticsConnections.png";
import clientAnalyticsAds from "./assets/clientAnalyticsAds.png";
import dashlanding from "./assets/dashlanding.png";
import dashboard from "./assets/dashboard.png";
import dashpanel from "./assets/dashpanel.png";
import realtorClip from "./assets/clips/realtor-mike-tan-property-crisis-reality-clip.mp4";
import richardClip from "./assets/clips/richard-brubaker-cofounder-redflag-clip.mp4";
import offshoringClip from "./assets/clips/back-room-offshoring-ai-advisory-clip.mp4";

export const projects = [
  {
    id: 1,
    projectTitle: "Automation Dashboard",
    outcome:
      "Centralized client automation monitoring so agencies can catch workflow issues faster.",
    businessProof: {
      builtFor: "Agencies and operators managing client automations",
      value:
        "Centralizes workflow visibility so teams can catch issues, explain progress, and protect client trust.",
    },
    serviceProof: [
      "Built from scratch",
      "Automation dashboard",
      "Client workflow visibility",
    ],
    description:
      "A from-scratch dashboard for agencies and operators managing automation work across multiple clients. It brings workflow activity from tools like Make and Zapier into one place so teams can monitor execution, explain progress, and catch issues faster.",
    tech: "React, Typescript, Supabase, Tailwind CSS, Make.com, JavaScript",
    images: [
      { image1: dashlanding },
      { image2: dashboard },
      { image3: dashpanel },
    ],
    webLink: "https://automation-dashboard-psi.vercel.app/",
    githubLink: "https://github.com/LaurenceLama/automation-dashboard",
  },
  {
    id: 2,
    projectTitle: "Summarist Library",
    outcome:
      "A from-scratch paid learning platform with signup, payments, reading, and audio in one product flow.",
    businessProof: {
      builtFor: "Content platforms and paid learning products",
      value:
        "Turns long-form knowledge into a smoother paid product with signup, access control, reading, and audio playback.",
    },
    serviceProof: [
      "Built from scratch",
      "Subscription platform",
      "Reading + audio experience",
    ],
    description:
      "Built fully from scratch as a subscription-based content platform for quick learning. Users can sign up, manage access through Stripe payments, and switch between reading and audio playback so long-form book insights become easier to consume.",
    tech: "NextJS, Typescript, Firebase, Stripe, Redux",
    images: [
      { image1: landingSumm },
      { image2: foryou },
      { image3: planSumm },
      { image4: player },
    ],
    webLink: "https://advanced-internship-ten.vercel.app",
    githubLink: "https://github.com/LaurenceLama/advanced-internship",
  },
  {
    id: 3,
    projectTitle: "AM DePrisco Ecommerce Website",
    outcome:
      "A luxury Shopify storefront shaped around product discovery and a smoother buying path.",
    businessProof: {
      builtFor: "Luxury ecommerce brands and Shopify stores",
      value:
        "Supports product discovery, collection browsing, and cart flow for customers ready to buy online.",
    },
    serviceProof: [
      "Ecommerce development",
      "Shopify storefront",
      "Customer shopping flow",
    ],
    description:
      "Shopify ecommerce work for a fine jewelry business, focused on the public storefront experience, product browsing, collection presentation, and practical store updates that support real customers.",
    tech: "Shopify, ecommerce management, storefront updates, product presentation, customer shopping flow",
    images: [
      { image1: amDepriscoHome },
      { image2: amDepriscoCollection },
      { image3: amDepriscoCart },
    ],
    webLink: "https://amdeprisco.com/",
    githubLink: "",
  },
  {
    id: 4,
    projectTitle: "Client Analytics Dashboard",
    outcome:
      "Unified ads, traffic, and store metrics so owners can understand performance without jumping between platforms.",
    businessProof: {
      builtFor: "Online stores tracking ads, traffic, and sales",
      value:
        "Pulls scattered platform data into one reporting view so owners can understand performance faster.",
    },
    serviceProof: [
      "Business analytics",
      "Live platform data",
      "Reporting dashboard",
    ],
    description:
      "A live analytics dashboard for online businesses that pulls important performance metrics from platforms like Google Analytics, Search Console, Google Ads, Meta Ads, and Shopify into one clear reporting view.",
    tech: "React, Typescript, Supabase, Google Cloud, Google Ads, Meta Ads, Shopify",
    images: [
      { image1: clientAnalyticsOverview },
      { image2: clientAnalyticsConnections },
      { image3: clientAnalyticsAds },
    ],
    webLink: "https://client-analytics-dashboard-five.vercel.app",
    githubLink: "",
  },
  {
    id: 5,
    projectTitle: "Podcast Clip Editing",
    outcome:
      "AI-assisted short-form clips that help business brands publish faster and stay visible.",
    businessProof: {
      builtFor: "Founders, podcasts, and business educators",
      value:
        "Turns long conversations into polished short clips that help brands publish faster and stay visible.",
    },
    serviceProof: [
      "Video editing",
      "AI-assisted clipping",
      "Social-ready clips",
    ],
    description:
      "Short-form business and podcast clips shaped from long-form conversations, with attention to pacing, context, captions, and platform-ready storytelling.",
    tech: "Video editing, clip selection, pacing, subtitles, social media formatting",
    images: [
      { video: realtorClip, label: "Real estate market insight clip" },
      { video: richardClip, label: "Founder red flag discussion clip" },
      { video: offshoringClip, label: "AI advisory business clip" },
    ],
    webLink: "",
    githubLink: "",
  },
];
